module.exports = __webpack_public_path__ + "static/img/bus-icon.6617976b.svg";